// dispatch-actions.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

export const dispatchActionsGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const actionClasses = route.data['actions'] as any[] | undefined;

  if (!actionClasses?.length) return true;

  const actions = actionClasses.map((ActionClass) => new ActionClass());
  return store.dispatch(actions).pipe(map(() => true));
};